import client from "services/ngage/api-client";
import DataResource from "types/DataResource";
import {AppInfo} from "types/AppInfo";
import {snakeKeys} from "services/array";
import deserializeAppInfo from "services/ngage/deserializers/app-info";
import {QrCodeFormat} from "types/QrCode";

type AppFilters = {
    include?: string
    page?: number
    perPage?: number
}

/**
 * Get all apps (paginated)
 */
const all = async (filters: AppFilters = {}) => {
    const params = Object.assign({page: 1, per_page: 100}, snakeKeys(filters))

    try{
        const page = (await client.get<DataResource<AppInfo> | null>('/apps', {params})).data

        if (page) page.data = page.data.map(deserializeAppInfo)

        return page
    } catch (error) {
        console.error("Unable to fetch apps", error)
        return null
    }
}

/**
 * Get the download URL for an app QR code
 *
 * @param id
 * @param format
 * @param subdomain
 */
const downloadQrCodeUrl = (id: number, format: QrCodeFormat, subdomain?: string | null) => {
    const operatorParameter = subdomain? `?operator=${subdomain}` : '';
    return `${client.defaults.baseURL}/apps/${id}/qr-code/${format}${operatorParameter}`
}

/**
 * Get the URL to open the audience app
 */
const openUrl = () => {
    return `${client.defaults.baseURL}/audience-app`
}

const apps = {
    all,
    downloadQrCodeUrl,
    openUrl
}

export default apps;